import { KoobMapMarker } from '@koob/maps';
import { koobMarker } from '@koob/map-marker';

const hotelIcon = {
  default: koobMarker('hotel'),
  active: koobMarker('hotel', { filled: true }),
};

/**
 * A pin with either a ready-made `popup` or, for plain places, a short
 * name / address popup.
 */
const MapMarker = ({ lat, lon, popup, title, Icon, name, address, label }) => {
  const icon = Icon ?? hotelIcon;
  const heading = name ?? title;
  const placePopup = (heading || address) && (
    <div className="w-60 py-3 pl-3.5 pr-11 text-left">
      {heading && (
        <div className="text-[15px] font-semibold leading-snug text-gray-900">
          {heading}
        </div>
      )}
      {address && (
        <div className="mt-1 flex gap-1.5 text-xs text-gray-500">
          <i className="fa-light fa-location-dot mt-0.5" />
          <span>{address}</span>
        </div>
      )}
    </div>
  );

  return (
    <KoobMapMarker
      lat={lat}
      lng={lon}
      title={heading}
      icon={icon.default}
      activeIcon={icon.active}
      label={label}
      popup={popup ?? placePopup}
    />
  );
};

export default MapMarker;
